module.exports = __webpack_public_path__ + "img/Conveyance.c218f6cf.svg";